import moment from 'moment';

export function formatDate(value: Date | string, format: string = 'D. MMM. YYYY HH:mm') {
    if (value == null || value === '') { return ''; }

    return moment(value).format(format);
}